import { client } from '../client';
import { IVideo } from '../communication/types/IVideo';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const getActiveVideoRoom = async (case_id: number, userRole?: string): Promise<IVideo> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.get(`${prefix}/cases/${case_id}/active_video_room`);

  return data;
};
